import {takeEvery, all, call} from 'redux-saga/effects';
import {GET_CONTENT_ITEM_WORK_HISTORY} from '../ContentItemViewWorkHistoryActions';
import {workHistory} from './workers';

function* watchWorkHistoryWorker() {
    yield takeEvery(GET_CONTENT_ITEM_WORK_HISTORY, workHistory);
}

export function* watchContentItemWorkHistory() {
    yield all([call(watchWorkHistoryWorker)]);
}
